import { Screen } from "quasar"
import { managerRoutes, technicianRoutes } from "src/router/routes/routes"
import { useApiAbortStore } from "src/stores/apiAbortStore"
import { useFilterStore } from "src/stores/filterStore"
import { useManagerTopNavigationStore } from "src/stores/managerTopNavigationStore"
import { useSearchStore } from "src/stores/searchStore"
import { useSupportStore } from "src/stores/supportStore"
import { useTopNavigationStore } from "src/stores/topNavigationStore"
import { NamedPath } from "src/util/enums/namedPaths"
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from "vue-router"

const createHistory = process.env.SERVER
  ? createMemoryHistory
  : process.env.VUE_ROUTER_MODE === "history"
    ? createWebHistory
    : createWebHashHistory

const router = createRouter({
  scrollBehavior: (to) => {
    // Go to anchor
    if (to.hash) {
      return {
        el: to.hash,
        top: Screen.height / 2, // Put it in the middle
        behavior: "smooth",
      }
    } else {
      return { left: 0, top: 0 }
    }
  },

  routes: process.env.IS_MANAGER_MODE ? managerRoutes : technicianRoutes,

  // Capacitor and Electron will always be in hash mode as it is the only thing it supports.
  history: createHistory(process.env.VUE_ROUTER_BASE),
})

if (process.env.IS_MANAGER_MODE) {
  router.beforeEach((to, from) => {
    // If the route is changed because of the addition of the filter params,
    // no need to execute the rest of the function
    if (to.name === from.name) return

    const topNavigationStore = useManagerTopNavigationStore()
    topNavigationStore.$reset()

    const supportStore = useSupportStore()
    supportStore.feedback = {}

    const apiAbortStore = useApiAbortStore()
    apiAbortStore.abortControllers()

    const filterStore = useFilterStore()
    filterStore.$reset()
  })
} else {
  router.beforeResolve((to, from) => {
    // If the route is changed because of the addition of the filter params,
    // no need to execute the rest of the function
    if (to.name === from.name) return

    // Make sure the search bar is not present
    const searchStore = useSearchStore()
    searchStore.resetIntermediateData()

    const topNavigationStore = useTopNavigationStore()
    // We don't want to reset the store if we do internal TO_DO navigation
    // This is also because we use router.replace
    if (to.name !== NamedPath.TO_DO || from.name !== to.name) {
      topNavigationStore.$reset()
    }

    const supportStore = useSupportStore()
    supportStore.feedback = {}

    const apiAbortStore = useApiAbortStore()
    apiAbortStore.abortControllers()

    const filterStore = useFilterStore()
    filterStore.$reset()
  })
}

export default router
